import React, { useEffect, useState } from 'react';

import { ClassNameMap } from '@material-ui/core/styles/withStyles';

import Image from '../../../../../../../../components/Image';

import { hasQueryParams } from '../../../../../../../../helpers/hasQueryParams';
import PhotoOverlay from '../PhotoOverlay/PhotoOverlay';
import { usePlayerSettings } from '@/app/state/ui/discoverySlice/index.hooks';
import { useDiscoveryUIDialog } from '@/app/pages/discovery/selectors/index.hooks';
import useLocalStorage from '@/app/hooks/useLocalStorage';
import { isEmpty } from 'lodash';
import { usePrivileges } from '@/app/state/auth/index.hooks';

interface IOwnProps {
    classes: ClassNameMap;
    apiPreview: string;
    apiDownload: string;
    name?: string;
    valid?: boolean;
    download?: string;
    type?: string;
    paramName: string;
    reportId: string;
}

const ImageWithActions = ({
    classes,
    apiPreview,
    apiDownload,
    name,
    valid,
    download,
    type,
    paramName,
    reportId,
}: IOwnProps) => {
    const dialogData = useDiscoveryUIDialog();
    const playerSettingsStorageName = 'playerSettings';
    const [localStorageSettings] = useLocalStorage(
        playerSettingsStorageName,
        null
    );
    const privileges = usePrivileges();
    const playerSettings = usePlayerSettings();
    const initPlayerSettings = dialogData?.videoParams?.playerSettings ||
        (!isEmpty(localStorageSettings) && localStorageSettings) ||
        playerSettings || { anonymize: privileges.anonymize };
    const initialAnonymize = initPlayerSettings?.anonymize;
    const { anonymize } = playerSettings || { anonymize: privileges.anonymize };
    const displayOverlay = type === 'movieFrame' || type === 'frameDetails';

    const anonymizeQueryParam = hasQueryParams(apiPreview)
        ? '&anonymize='
        : '?anonymize=';

    const [previewImageUrl, setPreviewImageUrl] = useState(
        `${apiPreview}${anonymizeQueryParam}${initialAnonymize}`
    );
    const [downloadImageUrl, setDownloadImageUrl] = useState(
        `${apiDownload}${anonymizeQueryParam}${initialAnonymize}`
    );

    useEffect(() => {
        const updatedPreviewUrl = `${apiPreview}${anonymizeQueryParam}${anonymize}`;
        setPreviewImageUrl(updatedPreviewUrl);
    }, [apiPreview, anonymize]);

    useEffect(() => {
        const updatedDownloadUrl = `${apiDownload}${anonymizeQueryParam}${anonymize}`;
        setDownloadImageUrl(updatedDownloadUrl);
    }, [apiDownload, anonymize]);

    return (
        <div className={classes.photoContainer}>
            <Image
                apiDownload={downloadImageUrl}
                imageUrl={previewImageUrl}
                name={name}
                valid={valid}
                download={download}
                paramName={paramName}
            />
            {displayOverlay && (
                <div className={classes.photoOverlay}>
                    <PhotoOverlay
                        paramName={paramName}
                        type={type}
                        reportId={reportId}
                        initPlayerSettings={initPlayerSettings}
                    />
                </div>
            )}
        </div>
    );
};

export default ImageWithActions;
